var _defs, _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 500 500",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "ArtboardFrame"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 500,
    width: 500,
    x: 0,
    y: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ArtboardFrame)",
    id: "Capa-1"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 270.99C500 270.99 391.947 388.571 329.755 398.432C267.562 408.293 254.126 407.412 254.126 407.412",
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 8.05796
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.616 275.013C499.616 275.013 391.561 157.431 329.369 147.569C267.177 137.708 253.742 138.589 253.742 138.589",
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 8.05796
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.507 287.956C26.507 287.956 129.575 390.916 188.899 399.551C248.221 408.185 261.037 407.415 261.037 407.415",
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 8.05796
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.91782 287.264L247.954 287.264",
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 8.05796
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.884 92.5669L250.884 291.111",
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 8.05796
  })), /*#__PURE__*/React.createElement("path", {
    d: "M125.423 285.805L126.1 212.003L105.671 212.308L105.529 196.662L142.389 181.768L141.816 150.023L164.942 150.023L164.514 166.956L206.562 137.273L254.421 176.674",
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 8.05796
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.496 138.574C257.551 138.574 254.662 138.831 251.765 139.017L251.765 289.721L127.2 289.721C135.43 356.076 191.914 407.433 260.496 407.433C334.738 407.433 394.897 347.275 394.897 273.032C394.897 198.79 334.738 138.574 260.496 138.574Z",
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 8.05796
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.395 193.589C210.543 193.589 175.036 229.154 175.036 273.004C175.036 316.854 210.543 352.417 254.395 352.417C298.245 352.417 333.806 316.854 333.806 273.004C333.806 262.998 331.771 253.526 328.393 244.709C322.495 253.696 312.369 259.629 300.816 259.629C282.585 259.629 267.767 244.868 267.767 226.637C267.767 215.084 273.755 204.903 282.743 199.005C273.925 195.628 264.4 193.589 254.395 193.589Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipRule: "nonzero",
    id: "ClipPath"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.395 193.589C210.543 193.589 175.036 229.154 175.036 273.004C175.036 316.854 210.543 352.417 254.395 352.417C298.245 352.417 333.806 316.854 333.806 273.004C333.806 262.998 331.771 253.526 328.393 244.709C322.495 253.696 312.369 259.629 300.816 259.629C282.585 259.629 267.767 244.868 267.767 226.637C267.767 215.084 273.755 204.903 282.743 199.005C273.925 195.628 264.4 193.589 254.395 193.589Z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ClipPath)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.935 102.376L336.399 473.419L169.908 472.197L172.443 101.154L338.935 102.376Z",
    fill: "#770088",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.935 102.376L336.399 473.419L197.656 472.4L200.192 101.358L338.935 102.376Z",
    fill: "#004cff",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.935 102.376L336.399 473.419L225.405 472.605L227.94 101.561L338.935 102.376Z",
    fill: "#028121",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.935 102.376L336.399 473.419L253.153 472.809L255.689 101.765L338.935 102.376Z",
    fill: "#ffee00",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.935 102.376L336.399 473.419L280.902 473.012L283.438 101.97L338.935 102.376Z",
    fill: "#ff8d00",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.935 102.376L336.399 473.419L308.65 473.215L311.186 102.173L338.935 102.376Z",
    fill: "#e50000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.04d9c5043178a7bfbf7bd1cc4aaa2697.svg";
export { ForwardRef as ReactComponent };